import React from 'react';
import moment from 'moment';
import getOr from '~/util/getOr';
import classnames from 'classnames/bind';

import GraphQLEventCard from '~/components/GraphQLEventCard/GraphQLEventCard';
import StyledComponent from '~/components/Styled/Styled';
import GraphQLEventDescriptionContainer from '~/containers/GraphQLEventDescriptionContainer/GraphQLEventDescriptionContainer';
import TodaysAlertsTooltip from '~/components/TodaysAlertsTooltip/TodaysAlertsTooltip';

import Layout from '~/components/Layout/Layout';
import Schedule from '~/components/Schedule/Schedule';

// @ts-ignore
import { Link } from '~/routes';

import css from './GraphQLMatchup.scss';

const cssContext = classnames.bind(css);

interface Props {
  after: string;
  league: string;
  events: [
    {
      node: {
        id: string;
        bareId: number;
      };
    }
  ];
  schedule: [
    {
      id: string;
    }
  ];
  inFuture: string;
}

interface State {
  selectedEvent: any;
  openTooltip: boolean;
}

class GraphQLMatchup extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      selectedEvent: null,
      openTooltip: false,
    };
  }

  onEventClicked(e, node) {
    e.currentTarget.classList.toggle(css.resultEventCardSelected);
    this.setState({ selectedEvent: node });
  }

  renderGetTodaysAlerts() {
    const { league } = this.props;
    return (
      <button
        className={css.getTodaysAlerts}
        onClick={() => this.setState({ openTooltip: true })}
        onBlur={e => {
          const { currentTarget } = e;
          setTimeout(() => {
            if (!currentTarget.contains(document.activeElement)) {
              this.setState({ openTooltip: false });
            }
          }, 0);
        }}
      >
        Get Today&#39;s Alerts
        {this.state.openTooltip && (
          <div className={css.getTodaysAlertsTooltip}>
            <TodaysAlertsTooltip
              closeClick={() => setTimeout(() => this.setState({ openTooltip: false }), 0)}
              leagueSlug={league}
            />
          </div>
        )}
      </button>
    );
  }

  render() {
    const { events, after, league, schedule, inFuture } = this.props;

    return (
      <Layout>
        <Schedule data={schedule} selected={inFuture ? schedule[schedule.length - 1].id : after} />
        <div className={css.desktopView}>
          <div className={css.scheduleTimeLabel}>{moment(after, 'YYYY-MM').format('MMMM')}</div>
        </div>
        <div className={css.mobileView}>
          <div className={css.scheduleTimeLabel}>{moment(after, 'YYYY-MM').format('MMMM')}</div>
          {this.renderGetTodaysAlerts()}
        </div>
        <div className={css.resultsEventCardContainer}>
          {events.map((elem, i) => {
            const node = getOr(elem, 'node', {});
            const resultEventCardClasses = cssContext(css.resultsEventCard, {
              seperator: i,
              resultEventCardSelected: this.state.selectedEvent
                ? this.state.selectedEvent.id === node.id
                : false,
            });

            return (
              <div key={node.id}>
                <div
                  className={`${css.desktopView} ${resultEventCardClasses}`}
                  role="presentation"
                  onClick={e => {
                    this.onEventClicked(e, node);
                  }}
                >
                  <GraphQLEventCard event={node} />
                </div>
                <div className={`${css.mobileView} ${resultEventCardClasses}`}>
                  <Link to={`/${league}/events/${node.bareId}`}>
                    <a>
                      <GraphQLEventCard event={node} />
                    </a>
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
        <div className={`${css.resultsEventCardContainer} ${css.desktopView}`}>
          <GraphQLEventDescriptionContainer event={this.state.selectedEvent} league={league} />
        </div>
      </Layout>
    );
  }
}

export default StyledComponent(GraphQLMatchup, [css]);
